module.exports = "<p>\n  map-example works!\n</p>\n\n<div style=\"height: 300px;\"\n     leaflet\n     [leafletOptions]=\"leafletOptions\">\n</div>\n"